<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="4" :lg="4" :md="4" :sm="24">
            <a-form-item label="">
              <a-input
                placeholder="作业名"
                v-model="queryParam.workName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="4" :md="4" :sm="24">
            <a-form-item label="">
               <j-dict-select-tag type="list" v-model="queryParam.workName" :trigger-change="true" dictCode="additional_work_status" placeholder="状态" style="width:100px"/>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="4" :md="4" :sm="24">
            <a-form-item label="">
              <j-select-depart
                :onlyCategory="3"
                :onlyMyDepart="true"
                :multi="false"
                placeholder="班级"
                v-model="queryParam.workDept"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="10" :lg="10" :md="10" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a-button
                @click="handleAdd"
                type="primary"
                icon="plus"
                style="margin-left: 8px"
                >布置作业</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <a-divider></a-divider>
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="text"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无文件</span
          >
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="getQiniuFile(text)"
          >
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <teacherAdditionalWork-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></teacherAdditionalWork-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import JSelectDepart from "@/components/jeecg/JSelectDepart";
import JDictSelectTag from '@/components/jeecg/JDictSelectTag'
import TeacherAdditionalWorkModal from "./modules/TeacherAdditionalWorkModal";

export default {
  name: "TeacherAdditionWork",
  mixins: [JeecgListMixin],
  components: {
    JSelectDepart,
    TeacherAdditionalWorkModal,
    JDictSelectTag
  },
  data() {
    return {
      description: "附加作业管理页面",
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "",
          key: "rowIndex",
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          },
        },
        {
          title: "代码类型",
          align: "center",
          dataIndex: "codeType_dictText",
        },
        {
          title: "作业名",
          align: "center",
          dataIndex: "workName",
        },
        // {
        //   title: "作业描述",
        //   align: "center",
        //   dataIndex: "workDesc",
        // },
        {
          title: "作业封面",
          align: "center",
          dataIndex: "workCover_url",
          scopedSlots: { customRender: "imgSlot" },
        },
        {
          title: "作业文件",
          align: "center",
          dataIndex: "workUrl_url",
          scopedSlots: { customRender: "fileSlot" },
        },
        {
          title: "分配班级",
          align: "center",
          dataIndex: "workDept_dictText",
        },
        // {
        //   title: "作业积分",
        //   align: "center",
        //   dataIndex: "workIntegral",
        // },
        {
          title: '状态',
          dataIndex: 'status_dictText'
        },
        {
          title: "创建日期",
          align: "center",
          dataIndex: "createTime",
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "center",
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: "action" },
        },
      ],
      url: {
        list: "/teaching/teachingAdditionalWork/teacherList",
        delete: "/teaching/teachingAdditionalWork/delete",
        deleteBatch: "/teaching/teachingAdditionalWork/deleteBatch",
      },
      dictOptions: {},
    };
  },
  methods:{
      searchQuery(){
          if(this.queryParam.workDept){
              this.queryParam.workDept = "*"+this.queryParam.workDept+"*"
          } 
          this.loadData(1);
      }
  }
};
</script>

<style>
</style>